import type { CampaignTemplate } from '@/data'
import type { TemplatePayload } from './createTemplate'
import api from '../..'

export async function updateTemplate(
  campaignId: string,
  templateId: string,
  payload: Partial<TemplatePayload>,
): Promise<CampaignTemplate> {
  const res = await api.put(
    `/campaigns/${campaignId}/templates/${templateId}`,
    payload,
  )
  return res.data.data
}
